var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { Slider as BaseSlider, Rail, Handles, Tracks } from 'react-compound-slider';
import { Box } from "../..";
import { Handle, SliderRail, Track } from './';
export var Slider = function (_a) {
    var id = _a.id, domain = _a.domain, step = _a.step, value = _a.value, height = _a.height, disabled = _a.disabled, handleTagDisplay = _a.handleTagDisplay, wrapperLss = _a.wrapperLss, setLeftInputValue = _a.setLeftInputValue, setRightInputValue = _a.setRightInputValue, onChange = _a.onChange, setHasLeftError = _a.setHasLeftError, setHasRightError = _a.setHasRightError;
    return (React.createElement(Box, { lss: wrapperLss, "aria-hidden": "true" },
        React.createElement(BaseSlider, { values: value, domain: domain, rootStyle: { width: '100%' }, onChange: function (_a) {
                var _b = __read(_a, 2), left = _b[0], right = _b[1];
                onChange && onChange([left, right]);
            }, onUpdate: function (_a) {
                var _b = __read(_a, 2), left = _b[0], right = _b[1];
                setLeftInputValue(left);
                setRightInputValue(right);
                setHasRightError(false);
                setHasLeftError(false);
            }, mode: 1, step: step, disabled: disabled },
            React.createElement(Rail, null, function (_a) {
                var getRailProps = _a.getRailProps;
                return (React.createElement(SliderRail, { getRailProps: getRailProps, height: height }));
            }),
            React.createElement(Handles, null, function (_a) {
                var handles = _a.handles, getHandleProps = _a.getHandleProps;
                return (React.createElement(Box, null, handles.map(function (handle) { return (React.createElement(Handle, { idPrefix: id, key: handle.id, handle: handle, domain: domain, getHandleProps: getHandleProps, height: height, disabled: disabled, handleTagDisplay: handleTagDisplay })); })));
            }),
            React.createElement(Tracks, { left: false, right: false }, function (_a) {
                var tracks = _a.tracks, getTrackProps = _a.getTrackProps;
                return (React.createElement(Box, null, tracks.map(function (_a) {
                    var id = _a.id, source = _a.source, target = _a.target;
                    return (React.createElement(Track, { key: id, source: source, target: target, getTrackProps: getTrackProps, height: height, disabled: disabled }));
                })));
            }))));
};
//# sourceMappingURL=Slider.js.map